module.exports = __webpack_public_path__ + "static/img/product_cp_1.7bda1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product_cp_1.png
// module id = WaGv
// module chunks = 1